<template>
  <div>
    <h4 class="title">Notification</h4>
    <!-- <div class="field">
      <label class="label">प्रयोगकर्ता</label>
      <a-tree-select
        v-model="value"
        style="width: 100%"
        :tree-data="treeData"
        tree-checkable
        :show-checked-strategy="SHOW_PARENT"
        placeholder="प्रयोगकर्ता चयन गर्नुहोस्"
        :class="{ 'is-danger': errors.users }"
      />
      <p class="help is-danger" v-if="errors.users">
        प्रयोगकर्ता चयन आवश्यक छ।
      </p>
    </div> -->
    <div class="field">
      <label class="label"> विषय</label>
      <div class="control">
        <input
          class="input"
          v-model="form.title"
          type="text"
          placeholder="फाइलको नाम"
          :class="{ 'is-danger': errors.title }"
        />
        <p class="help is-danger" v-if="errors.title">विषय आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <div class="label">फोटो</div>
      <div class="control">
        <div class="file has-name">
          <label class="file-label">
            <input
              class="file-input"
              type="file"
              ref="file"
              @change="upload"
              accept=".png, .jpg, .jpeg"
            />
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label"> Choose a file </span>
            </span>
            <span class="file-name" style="min-width: 230px">
              {{ fileName }}
            </span>
          </label>
        </div>
        <p class="help is-danger" v-if="errors.image">फोटो आवश्यक छ।</p>
      </div>
    </div>
    <div class="field">
      <label class="label">सन्देश</label>
      <div class="control">
        <textarea
          class="textarea"
          placeholder="सन्देश लेख्नुहोस्"
          v-model="form.message"
          :class="{ 'is-danger': errors.message }"
        ></textarea>
        <p class="help is-danger" v-if="errors.message">सन्देश आवश्यक छ।</p>
      </div>
    </div>
    <button
      class="button submit pbutton"
      :class="{ 'is-loading': loading }"
      @click="validate"
    >
      सूचना पठाउनुहोस्
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "../../main";
import { TreeSelect } from "ant-design-vue";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const treeData = [
  // {
  //   title: "CEO",
  //   value: "CEO",
  //   key: "CEO",
  // },
  // {
  //   title: "CFO",
  //   value: "CFO",
  //   key: "CFO",
  // },
  // {
  //   title: "COO",
  //   value: "COO",
  //   key: "COO",
  // },
  // {
  //   title: "CTO",
  //   value: "CTO",
  //   key: "CTO",
  // },
  // {
  //   title: "CMO",
  //   value: "CMO",
  //   key: "CMO",
  // },
  // {
  //   title: "VP of Engineering",
  //   value: "VP of Engineering",
  //   key: "VP of Engineering",
  // },
  // {
  //   title: "VP of Marketing",
  //   value: "VP of Marketing",
  //   key: "VP of Marketing",
  // },
  // {
  //   title: "HR Manager",
  //   value: "HR Manager",
  //   key: "HR Manager",
  // },
  // {
  //   title: "Finance Manager",
  //   value: "Finance Manager",
  //   key: "Finance Manager",
  // },
  // {
  //   title: "Product Manager",
  //   value: "Product Manager",
  //   key: "Product Manager",
  // },
  // {
  //   title: "Project Manager",
  //   value: "Project Manager",
  //   key: "Project Manager",
  // },
  // {
  //   title: "Software Engineer",
  //   value: "Software Engineer",
  //   key: "Software Engineer",
  // },
  // {
  //   title: "Data Scientist",
  //   value: "Data Scientist",
  //   key: "Data Scientist",
  // },
  // {
  //   title: "UI/UX Designer",
  //   value: "UI/UX Designer",
  //   key: "UI/UX Designer",
  // },
  // {
  //   title: "Quality Assurance Engineer",
  //   value: "Quality Assurance Engineer",
  //   key: "Quality Assurance Engineer",
  // },
  // {
  //   title: "Business Analyst",
  //   value: "Business Analyst",
  //   key: "Business Analyst",
  // },
  // {
  //   title: "Sales Manager",
  //   value: "Sales Manager",
  //   key: "Sales Manager",
  // },
  // {
  //   title: "Customer Support Representative",
  //   value: "Customer Support Representative",
  //   key: "Customer Support Representative",
  // },
//   {
//     title: "Other",
//     value: "Other",
//     key: "Other",
//   },
];
export default {
  data() {
    return {
      form: {
        title: "",
        message: "",
        image: null,
      },
      loading: false,
      fileName: "",
      edit: false,
      value: [],
      roles: [],
      treeData,
      SHOW_PARENT,
      errors: {
        users: false,
        title: false,
        message: false,
        image: false,
      },
    };
  },
  methods: {
    resetErrors() {
      this.errors = {
        users: false,
        title: false,
        message: false,
        image: false,
      };
    },
    upload() {
      const file = this.$refs.file.files[0];

      // Check if the file type is valid
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (file && validTypes.includes(file.type)) {
        this.fileName = file.name;
        this.form.image = file;
        this.errors.image = false;
      } else {
        // If the file is invalid, reset the input and show an error
        this.fileName = "";
        this.form.image = null;
        this.errors.image = true;
        this.$notify.error({
          position: "bottom right",
          msg: "Only .png, .jpg, and .jpeg files are allowed!",
          timeout: 2000,
        });
        this.$refs.file.value = ""; // Reset the file input
      }
    },
    clearForm() {
      this.form = {
        title: "",
        message: "",
        image: null,
      };
      this.fileName = "";
      this.value = [];
      this.roles = [];
      this.resetErrors();
    },
    validate() {
      this.resetErrors();

      // Check all required fields
      this.errors.users = this.value.length === 0;
      this.errors.title = !this.form.title;
      this.errors.message = !this.form.message;
      this.errors.image = !this.form.image;

      // If no errors, proceed with save
      if (
        // !this.errors.users &&
        !this.errors.title &&
        !this.errors.message &&
        !this.errors.image
      ) {
        this.saveVideo();
      }
    },
    saveVideo() {
      this.loading = true;
      const fd = new FormData();
      fd.append("title", this.form.title);
      fd.append("message", this.form.message);
      if (this.form.image !== null) {
        fd.append("image", this.form.image);
      }

      // this.roles = this.value.map((el) => ({ role: el }));
      // fd.append("roles", JSON.stringify(this.roles));
      fd.append("roles", JSON.stringify([{ role: "Other" }]));
      axios
        .post("/api/send-notification", fd)
        .then((res) => {
          this.loading = false;
          this.$notify.success({
            position: "bottom right",
            msg: "Notification sent successfully!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
          this.clearForm();
          bus.$emit("store", true);
        })
        .catch((err) => {
          this.loading = false;
          this.$notify.error({
            position: "bottom right",
            msg: "Notification could not be sent!",
            timeout: 2000,
            styles: {
              minWidth: null, // default 250
              maxWidth: "calc(100% - 40px)", // default 350
              width: 250, // default null
              height: 70,
            },
          });
        });
    },
  },
};
</script>

<style scoped>
.label {
  color: #6a6a6a;
  font-weight: 400;
}
.title {
  font-size: 1.5rem;
  margin-bottom: 0px;
  color: #254594;
  margin-bottom: 10px;
}
.pbutton {
  background: #254594;
  color: #fff;
  border-radius: 34px;
  width: 153px;
  height: 40px;
  margin-top: 30px;
}
.pbutton:hover {
  color: #fff;
}
.pbutton:focus {
  color: #fff;
}
.is-danger {
  border-color: #f14668;
}
:deep(.ant-select-selector) {
  border-color: #f14668 !important;
}
</style>
